module.exports = __webpack_public_path__ + "static/media/dumbbell.749a534e.svg";